import React, { useState } from 'react';
import Icon from 'components/AppIcon';
import Image from 'components/AppImage';

const TestimonialsSection = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const testimonialsData = {
    title: "Lo Que Dicen Nuestros Clientes",
    subtitle: "What Our Customers Say",
    description: "La satisfacción de nuestros clientes es nuestro mayor logro. Estas son algunas de las experiencias que han compartido con nosotros.",
    testimonials: [
      {
        id: 1,
        name: "Roberto Jiménez",
        location: "Escazú, San José",
        service: "Mantenimiento Mensual",
        rating: 5,
        comment: `Excelente servicio. Llevo más de 3 años con BAC Pool CR y siempre han sido puntuales y profesionales. Mi piscina se mantiene cristalina todo el año.

El equipo es muy confiable y siempre me explican qué están haciendo y por qué. Definitivamente los recomiendo a cualquiera que busque un servicio de calidad.`,
        image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80",
        date: "Marzo 2024"
      },
      {
        id: 2,
        name: "Sarah Mitchell",
        location: "Santa Ana, San José",
        service: "Limpieza Semanal",
        rating: 5,
        comment: `As an expat living in Costa Rica, I was worried about finding reliable pool service. BAC Pool CR has exceeded my expectations. They speak excellent English and are always professional.

Their attention to detail is outstanding, and they've helped me understand pool maintenance in the tropical climate. Highly recommended!`,
        image: "https://images.unsplash.com/photo-1494790108755-2616b612b786?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80",
        date: "Febrero 2024"
      },
      {
        id: 3,
        name: "Carlos Vargas",
        location: "Cartago Centro",
        service: "Reparación de Equipos",
        rating: 5,
        comment: `Tuve un problema serio con el sistema de filtración de mi piscina. BAC Pool CR no solo lo solucionó rápidamente, sino que me enseñó cómo prevenir problemas futuros.

Su honestidad y transparencia en los precios es algo que valoro mucho. No tratan de vender servicios innecesarios, solo lo que realmente necesitas.`,
        image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80",
        date: "Enero 2024"
      },
      {
        id: 4,
        name: "María Elena Solís",
        location: "Heredia, Centro",
        service: "Mantenimiento Completo",
        rating: 5,
        comment: `Como administradora de un condominio con piscina, necesitaba un servicio confiable y profesional. BAC Pool CR ha sido la solución perfecta.

Siempre llegan a tiempo, trabajan de manera eficiente y mantienen excelente comunicación. Los residentes están muy satisfechos con el estado de la piscina.`,
        image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80",
        date: "Diciembre 2023"
      },
      {
        id: 5,
        name: "David Thompson",
        location: "Guanacaste, Tamarindo",
        service: "Servicio de Emergencia",
        rating: 5,
        comment: `We had a pool emergency during a family vacation rental. BAC Pool CR responded within hours and had our pool ready for guests the same day.

Their emergency service is exceptional, and they went above and beyond to ensure our guests had a great experience. True professionals!`,
        image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80",
        date: "Noviembre 2023"
      },
      {
        id: 6,
        name: "Ana Lucía Ramírez",
        location: "Alajuela, Centro",
        service: "Consultoría y Mantenimiento",
        rating: 5,
        comment: `Contraté BAC Pool CR cuando compré mi casa con piscina y no sabía nada sobre mantenimiento. Su equipo me educó sobre todo el proceso y ahora entiendo perfectamente el cuidado que necesita.

Su servicio educativo es tan valioso como el mantenimiento mismo. Gracias por la paciencia y profesionalismo.`,
        image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80",
        date: "Octubre 2023"
      }
    ]
  };

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => 
      prev === testimonialsData.testimonials.length - 1 ? 0 : prev + 1
    );
  };

  const prevTestimonial = () => {
    setCurrentTestimonial((prev) => 
      prev === 0 ? testimonialsData.testimonials.length - 1 : prev - 1
    );
  };

  const currentData = testimonialsData.testimonials[currentTestimonial];

  return (
    <section className="mb-16">
      <div className="text-center mb-12">
        <h2 className="text-3xl lg:text-4xl font-heading font-bold text-text-primary mb-4">
          {testimonialsData.title}
        </h2>
        <p className="text-lg text-text-secondary font-medium mb-6">
          {testimonialsData.subtitle}
        </p>
        <p className="max-w-3xl mx-auto text-text-secondary">
          {testimonialsData.description}
        </p>
      </div>

      {/* Featured Testimonial */}
      <div className="bg-surface rounded-lg border border-border shadow-medium p-8 mb-8">
        <div className="grid lg:grid-cols-3 gap-8 items-center">
          {/* Customer Info */}
          <div className="text-center lg:text-left">
            <div className="w-24 h-24 rounded-full overflow-hidden mx-auto lg:mx-0 mb-4">
              <Image
                src={currentData.image}
                alt={currentData.name}
                className="w-full h-full object-cover"
              />
            </div>
            <h3 className="font-heading font-bold text-text-primary text-xl mb-1">
              {currentData.name}
            </h3>
            <p className="text-text-secondary text-sm mb-2">
              {currentData.location}
            </p>
            <div className="flex justify-center lg:justify-start space-x-1 mb-2">
              {[...Array(currentData.rating)].map((_, i) => (
                <Icon key={i} name="Star" size={16} className="text-warning fill-current" />
              ))}
            </div>
            <span className="text-xs bg-primary/10 text-primary px-2 py-1 rounded">
              {currentData.service}
            </span>
          </div>

          {/* Testimonial Content */}
          <div className="lg:col-span-2">
            <div className="relative">
              <Icon name="Quote" size={32} className="text-primary/20 absolute -top-2 -left-2" />
              <div className="prose prose-lg max-w-none text-text-secondary pl-8">
                <p>{currentData.comment}</p>
              </div>
            </div>
            <div className="flex items-center justify-between mt-6">
              <span className="text-sm text-text-secondary">
                {currentData.date}
              </span>
              <div className="flex items-center space-x-2">
                <button
                  onClick={prevTestimonial}
                  className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center hover:bg-primary/20 nav-transition"
                >
                  <Icon name="ChevronLeft" size={20} className="text-primary" />
                </button>
                <span className="text-sm text-text-secondary">
                  {currentTestimonial + 1} / {testimonialsData.testimonials.length}
                </span>
                <button
                  onClick={nextTestimonial}
                  className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center hover:bg-primary/20 nav-transition"
                >
                  <Icon name="ChevronRight" size={20} className="text-primary" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Testimonial Thumbnails */}
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-8">
        {testimonialsData.testimonials.map((testimonial, index) => (
          <button
            key={testimonial.id}
            onClick={() => setCurrentTestimonial(index)}
            className={`p-4 rounded-lg border nav-transition ${
              index === currentTestimonial
                ? 'border-primary bg-primary/5' :'border-border bg-surface hover:border-primary/50'
            }`}
          >
            <div className="w-12 h-12 rounded-full overflow-hidden mx-auto mb-2">
              <Image
                src={testimonial.image}
                alt={testimonial.name}
                className="w-full h-full object-cover"
              />
            </div>
            <p className="text-xs font-medium text-text-primary text-center mb-1">
              {testimonial.name}
            </p>
            <p className="text-xs text-text-secondary text-center">
              {testimonial.location}
            </p>
          </button>
        ))}
      </div>

      {/* Trust Indicators */}
      <div className="bg-gradient-to-r from-primary/5 to-success/5 rounded-lg p-8">
        <div className="grid md:grid-cols-4 gap-6 text-center">
          <div>
            <div className="text-3xl font-heading font-bold text-primary mb-2">98%</div>
            <p className="text-sm text-text-secondary">Satisfacción del Cliente</p>
          </div>
          <div>
            <div className="text-3xl font-heading font-bold text-success mb-2">4.9</div>
            <p className="text-sm text-text-secondary">Calificación Promedio</p>
          </div>
          <div>
            <div className="text-3xl font-heading font-bold text-accent mb-2">95%</div>
            <p className="text-sm text-text-secondary">Clientes que Recomiendan</p>
          </div>
          <div>
            <div className="text-3xl font-heading font-bold text-primary mb-2">24h</div>
            <p className="text-sm text-text-secondary">Tiempo de Respuesta</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;